import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IShopifyStore } from "../../models/ShopifyStore/ShopifyStore";
import { ShopifyStoreQueryKeys } from "./keys";

export default function useShopifyStores(customerId: string) {
  const { get } = useApiHelper();

  const shopifyStores = useQuery({
    queryKey: ShopifyStoreQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<IShopifyStore[]>>(`/shopifystore/${customerId}`).then(
        (res) => res.data
      ),
  });

  return {
    shopifyStores,
  };
}
